import http from '../service/axios';
import { waitForMindboxDeviceUUID } from './mindbox';
import { mindboxLog } from './mindboxLog';

/**
 * Операции Mindbox, которые отправляет наш бэкенд (`POST /client/mb/*`).
 *
 * `Online.*` — операции серверного API: Mindbox принимает их только с
 * secretKey, а его во фронт класть нельзя. Поэтому мы отдаём бэкенду тело
 * события и deviceUUID, а он сам зовёт Mindbox синхронно и отвечает
 * `{ success, data: { status } }`.
 *
 * Бэкенду нужен тот же deviceUUID, что уехал с авторизацией, — случайный он не
 * генерирует. Пока профиль не загружен, ждём UUID из `/user/me`; не дождались —
 * запрос не шлём.
 */

// Токен кладёт авторизация, его же подставляет axios-перехватчик. Без него
// бэкенд ответит 401, поэтому для гостя события не отправляем.
export const hasAuthToken = () => Boolean(localStorage.getItem('token'));

type BackendResponse = {
  success?: boolean;
  data?: { status?: string };
};

export const mindboxBackendOperation = async (
  operation: string,
  path: string,
  data: Record<string, unknown>
): Promise<boolean> => {
  const label = `${operation} (backend)`;

  try {
    console.log(`[${label}] ждём deviceUUID…`);
    const deviceUUID = await waitForMindboxDeviceUUID();
    if (!deviceUUID) {
      console.warn(`[${label}] не отправлено: нет deviceUUID`, data);
      mindboxLog({
        kind: 'skip',
        operation: label,
        message: 'не отправлено: нет deviceUUID',
        payload: data,
      });
      return false;
    }

    const body = { deviceUUID, ...data };
    console.log(`[${label}] → POST ${path}`, body);
    mindboxLog({ kind: 'send', operation: label, message: 'отправляем', payload: body });

    const response = await http.post<BackendResponse>(path, body, {
      headers: { 'Content-Type': 'application/json' },
    });
    console.log(`[${label}] ← ${response.status}`, response.data);
    mindboxLog({ kind: 'ok', operation: label, message: 'ответ бэкенда', details: response.data });

    return Boolean(response.data?.success);
  } catch (error) {
    const failed = (error as { response?: { status?: number; data?: unknown } })?.response;
    console.error(`[${label}] ✕ ${failed?.status ?? 'сеть'}`, failed?.data ?? error);
    // 422 — бэкенду не понравились данные, 502 — Mindbox отклонил или лёг.
    // Аналитика сценарий не ломает: только журнал.
    mindboxLog({
      kind: 'error',
      operation: label,
      message: 'бэкенд не принял событие',
      payload: data,
      details: (error as { response?: unknown })?.response ?? error,
    });
    return false;
  }
};
